import styled from 'styled-components';
import { Space, Button } from 'antd';

export const AdminContainer = styled(Space)`
  width: 100%;
`;

export const SectionContainer = styled.div<{ marginTop?: string }>`
  margin-top: ${(props) => props.marginTop || '8px'};
`;

export const SectionHeader = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #666;
  margin-bottom: 4px;
`;

export const SectionContent = styled(Space)`
  width: 100%;
`;

export const AdminButton = styled(Button)`
  width: 100%;
  text-align: left;
  justify-content: flex-start;
`;

export const InfoBox = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 2px;
  margin-bottom: 2px;
  background: linear-gradient(135deg, #f5f7ff 0%, #fef5ff 100%);
  border: 1px solid #e0e7ff;
  border-radius: 6px;
  font-size: 13px;
  gap: 8px;
`;
